<template>
  <div class="primary-cost-estimate">
    <b-modal :active.sync="isModalActive">
      <div class="box modal-content">
        <b-field custom-class="has-text-white has-size-5" label="Name">
          <b-input v-model="pcSumName"></b-input>
        </b-field>
        <b-field custom-class="has-text-white has-size-5" label="Value">
          <b-input v-model="pcSumValue" type="number"></b-input>
        </b-field>
        <b-button @click="addPCSum()">Add</b-button>
        <b-button @click="togglePCSumInput(false)">Close</b-button>
      </div>
    </b-modal>
    <!--    <div v-if="isExternalUser === false && estimateStarted === false">-->
    <!--      <div class="create-pce-button">-->
    <!--        <b-button-->
    <!--            icon-left="plus"-->
    <!--            size="is-large"-->
    <!--            type="is-sucess"-->
    <!--            @click="createPrimaryCostEstimate"-->
    <!--        >-->
    <!--          <template v-if="estimateStarted === false">Create Primary Cost Estimate</template>-->
    <!--        </b-button>-->
    <!--      </div>-->
    <!--    </div>-->
    <button v-if="!isVisible" @click="toggleVisibility" class="button is-size-5 PCEButton">Show PCE:
      {{ totalWithProfit | currencyNotReduced }}
    </button>
    <div class="primary-cost-estimate-controller">
      <div class="estimate-builder-container">
        <section v-if="isVisible" class="estimate-config-container box white">
          <b-field custom-class="has-text-primary" label="Job Type">
            <b-input
              :value="jobType"
              expanded
              disabled
              readonly
            />
            <icon-and-card :card-image="jobTypeModifierDescription.image"
                           :card-text="jobTypeModifierDescription.text"
                           position="is-right"
            ></icon-and-card>
          </b-field>
          <b-field custom-class="has-text-primary" label="Location">
            <p class="control is-expanded">
              <b-dropdown
                :mobile-modal="true"
                :open-on-focus="true"
                aria-role="list"
                expanded
                scrollable
                size="is-medium"
                @input="option => (selectedLocation = option)"
              >
                <template #trigger="{ active }">
                  <b-input
                    :icon-right="active ? 'caret-up' : 'caret-down'"
                    :value="selectedLocation ? selectedLocation.region : 'Select Location'"
                    expanded
                    readonly/>
                </template>
                <b-dropdown-item
                  v-for="option in locationModifiers"
                  :key="option.region"
                  :value="option"
                >
                  {{ option.region }}
                </b-dropdown-item>
              </b-dropdown>
            </p>
            <icon-and-card :card-image="locationModifierDescription.image"
                           :card-text="locationModifierDescription.text"
                           position="is-right"
            ></icon-and-card>
          </b-field>
          <b-field v-for="(workSection, index) in workSectionsConfigWithModifiers" :key="index"
                   :label="workSection.label + ' Type'"
                   custom-class="has-text-primary">
            <p class="control is-expanded">
              <b-dropdown
                :mobile-modal="true"
                :open-on-focus="true"
                aria-role="list"
                expanded
                size="is-medium"
                @input="option => setSelectedModifier(workSection.name, option)"
              >
                <template #trigger="{ active }">
                  <b-input
                    :icon-right="active ? 'caret-up' : 'caret-down'"
                    :value="getSelectedModifierLabelForWorkSection(workSection)"
                    expanded
                    readonly/>
                </template>
                <b-dropdown-item
                  v-for="option in workSection.modifiers"
                  :key="option.name"
                  :value="option"
                >
                  {{ option.label }}
                </b-dropdown-item>
              </b-dropdown>
            </p>
            <icon-and-card :card-image="getSelectedModifierImageForWorkSection(workSection)"
                           :card-text="getSelectedModifierDescriptionForWorkSection(workSection)"
                           position="is-right"
            />
          </b-field>
          <div class="row">
            <b-field :message="!invalidSurfaceArea ? '' : 'Invalid surface area'"
                     :type="!invalidSurfaceArea ? null : 'is-danger'"
                     custom-class="has-text-primary"
                     label="Surface Area">
              <b-input v-model="surfaceAreaInput" :disabled="!selectedJobType"></b-input>
            </b-field>
            <b-field :message="!invalidMarkupPercentage ? '' : 'Invalid mark-up'"
                     :type="!invalidMarkupPercentage ? null : 'is-danger'"
                     custom-class="has-text-primary"
                     label="Profit Margin">
              <b-input v-model="markUpPercentage" :disabled="!selectedJobType"></b-input>
            </b-field>
          </div>
          <b-field>
            <b-checkbox v-model="displayWorkSectionTotalWithMarkUp">
              Display work section total with mark-up
            </b-checkbox>
          </b-field>
          <b-button v-if="!totalCalculationEnabled" :disabled="!selectedJobType || !surfaceAreaInput" class="button"
                    icon-left="calculator"
                    @click.native="calculateJobTotal"><span class="is-size-5">Calculate Estimate</span>
          </b-button>
          <b-button v-else class="button" icon-left="file"
                    @click.native="openReportGenerator()"><span class="is-size-5">Run Reports</span>
          </b-button>
          <div class="totals-container">
            <div class="box expanded has-bg-tertiary">
              <div class="total is-size-5 has-text-centered has-text-primary has-text-weight-semibold">
                <div class="total-label mb-1 has-text-centered">
                  <span>Total</span>
                  <span class="is-size-7">(ex VAT)</span>
                </div>
                <div class="total-value">
                  {{ total | currencyNotReduced }}
                </div>
              </div>
            </div>
            <div class="box expanded has-bg-tertiary">
              <div class="total is-size-5 has-text-centered has-text-primary has-text-weight-semibold">
                <div class="total-label mb-1 has-text-centered">
                  <span>Total with profit</span>
                  <span class="is-size-7">(ex VAT)</span>
                </div>
                <div class="total-value">
                  {{ totalWithProfit | currencyNotReduced }}
                </div>
              </div>
            </div>
          </div>
          <div class="buttons-container">
            <b-button :disabled="!totalCalculationEnabled" expanded icon-left="plus" type="button is-info"
                      @click="togglePCSumInput(true)">
              <span class="is-size-5">Add PCSum</span>
            </b-button>
            <b-button expanded icon-left="save" type="button is-success" @click="saveProjectProgress">
              <span class="is-size-5">Save Progress</span>
            </b-button>
          </div>
          <button v-if="isVisible" @click="toggleVisibility" class="button is-size-5">Hide PCE</button>
        </section>
        <section v-if="deviceIsMobile">
          <section id="mobileSliders" :class="{'hidden': !jobConfigLoaded}" class="estimate-values-container box white">
            <div v-for="(buildStage,index) in calculatedJobWorkSections" class="build-stage-container">
              <div class="mobileViewSliderLabel">
                {{ index | title }}
              </div>
              <div id="sliderSections" v-for="workSection in buildStage" class="work-section">
                <div id="mobileSliderLabelAndImage">
                  <b-field :label="workSection.label" id="sliderWorkSectionLabel" class="work-section-label"
                           custom-class="has-text-primary" horizontal>
                    <icon-and-card :card-image="getWorkSectionSpecImage(workSection)"
                                   :card-text="getWorkSectionSpecText(workSection)"
                                   :position="getTooltipPosition(index)"
                    />
                  </b-field>
                </div>
                <span id="mobileSliderSpan">
                  <b-checkbox v-model="workSection.enabled" :value="workSection.enabled" size="is-small"></b-checkbox>
                 <b-input v-if="!displayWorkSectionTotalWithMarkUp" :disabled="!workSection.enabled"
                          :value="workSection.enabled ?  workSection.calculatedTotalFormatted : ''"
                          label-position="on-border"
                          custom-class="has-text-primary"
                          label="No Mark-up"
                          class="has-text-right" readonly>
                           </b-input>
                           <b-input v-else disabled
                                    :value="workSection.enabled ? workSection.calculatedTotalWithMarkUpFormatted : ''"
                                    label-position="on-border"
                                    custom-class="has-text-primary"
                                    label="No Mark-up"
                                    class="has-text-right" readonly>
                           </b-input>
                  <b-slider v-model="workSection.percentageChange" :custom-formatter="(val) => val + '%'"
                            :disabled="!workSection.enabled" :max="100"
                            :min="-100" :value="0" class="work-section-slider" lazy
                            size="is-medium" tooltip-type="is-warning"></b-slider>
                </span>
              </div>
            </div>
            <div class="pc-sums-container">
              <div class="label has-text-primary has-half-border-bottom">
                Extra Provisional Sums
              </div>
              <div class="columns is-mobile">
                <div v-for="(pcSum, index) in pcSums" class="column is-4">
                  <b-tag aria-close-label="Close tag"
                         closable
                         size="is-medium"
                         type="is-primary"
                         @close="removePCSum(index)"
                         attached
                  >
                    <p class="has-text-white">{{ pcSum.name }} - {{ pcSum.value | currencyNotReduced }}</p>
                  </b-tag>
                </div>
              </div>
            </div>
          </section>
        </section>
        <section v-else>
          <section id="sliders" :class="{'hidden': !jobConfigLoaded}" class="estimate-values-container box white">
            <div v-for="(buildStage,index) in calculatedJobWorkSections" class="build-stage-container">
              <div class="label has-text-primary has-half-border-bottom">
                {{ index | title }}
              </div>
              <div id="sliderSections" v-for="workSection in buildStage" class="work-section">
                <b-checkbox v-model="workSection.enabled" :value="workSection.enabled" size="is-small"></b-checkbox>
                <b-field :label="workSection.label" class="work-section-label" custom-class="has-text-primary"
                         horizontal>
                  <icon-and-card :card-image="getWorkSectionSpecImage(workSection)"
                                 :card-text="getWorkSectionSpecText(workSection)"
                                 :position="getTooltipPosition(index)"
                  />
                  <b-input v-if="!displayWorkSectionTotalWithMarkUp" :disabled="!workSection.enabled"
                           :value="workSection.enabled ?  workSection.calculatedTotalFormatted : ''"
                           label-position="on-border"
                           custom-class="has-text-primary"
                           label="No Mark-up"
                           class="has-text-right" readonly>
                  </b-input>
                  <b-input v-else disabled
                           :value="workSection.enabled ? workSection.calculatedTotalWithMarkUpFormatted : ''"
                           label-position="on-border"
                           custom-class="has-text-primary"
                           label="No Mark-up"
                           class="has-text-right" readonly>
                  </b-input>
                  <!--                <b-input :disabled="!workSection.enabled"-->
                  <!--                         :value="workSection.enabled ? getWorkSectionTotal(workSection) : ''"-->
                  <!--                         label-position="on-border"-->
                  <!--                         label="Inc Mark-up"-->
                  <!--                         custom-class="has-text-primary"-->
                  <!--                         class="has-text-right" readonly>-->
                  <!--                </b-input>-->
                </b-field>
                <b-slider v-model="workSection.percentageChange" :custom-formatter="(val) => val + '%'"
                          :disabled="!workSection.enabled" :max="100"
                          :min="-100" :value="0" class="work-section-slider" lazy
                          size="is-medium" tooltip-type="is-warning"></b-slider>
              </div>
            </div>
            <div class="pc-sums-container">
              <div class="label has-text-primary has-half-border-bottom">
                Extra Provisional Sums
              </div>
              <div class="columns is-mobile">
                <div v-for="(pcSum, index) in pcSums" class="column is-4">
                  <b-tag aria-close-label="Close tag"
                         closable
                         size="is-medium"
                         type="is-primary"
                         @close="removePCSum(index)"
                         attached
                  >
                    <p class="has-text-white">{{ pcSum.name }} - {{ pcSum.value | currencyNotReduced }}</p>
                  </b-tag>
                </div>
              </div>
            </div>
          </section>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import filters from "../../../../../resource/module/filters";
import IconAndCard from "../../../../../resource/component/info-icon-and-card/component.vue";

export default {
  name: "overview",
  filters,
  components: {
    IconAndCard
  },
  props: {
    pceProgress: {
      type: Object,
      default: null
    }
  },
  beforeCreate() {
    if (this.$store.getters['pce/selectedJobType'] === null) {
      this.$router.push('/overview');
    }
  },
  created() {
    if (this.pceProgress) {
      this.selectedModifiers = this.pceProgress.selectedModifiers;
      this.surfaceAreaInput = this.pceProgress.surfaceAreaInput;
      this.markUpPercentage = this.pceProgress.markUpPercentage;
      this.calculatedJobWorkSections = this.pceProgress.calculatedJobWorkSections;
      this.selectedLocation = this.pceProgress.selectedLocation;
      this.pcSums = this.pceProgress.pcSums;
      this.workSectionsConfigWithModifiers = this.pceProgress.workSectionsConfigWithModifiers;
      this.enableTotalCalculation();
      this.jobConfigLoaded = true;
    } else {
      this.$store.commit('generic/showSearchBar', false);
      this.$store.dispatch('company/clearFilteredProjects');
      this.$store.dispatch('pce/fetchAndAssignJobConfig', this.selectedJobType).then(() => {
        this.setModifiers();
      });
    }

    this.$store.dispatch('pce/getPrimaryCostEstimateAppConfig');
  },
  data() {
    return {
      submissionForm: null,
      active: false,
      showSection: true,
      showButton: false,
      isVisible: true,
      estimateStarted: false,
      selectedLocation: null,
      surfaceAreaInput: null,
      markUpPercentage: null,
      invalidMarkupPercentage: false,
      invalidSurfaceArea: false,
      jobConfigLoaded: false,
      totalCalculationEnabled: false,
      showForm: false,
      isModalActive: false,
      pcSumName: '',
      pcSumValue: 0,
      displayWorkSectionTotalWithMarkUp: false,
      calculatedJobWorkSections: [],
      workSectionsConfigWithModifiers: [],
      pcSums: [],
      selectedModifiers: {},
      projectAddress: {
        line1: '1 Test Street',
        line2: 'Test Town',
        town: 'Test Town',
        postcode: 'TE5 7PC',
      }
    }
  },
  watch: {
    'surfaceAreaInput': {
      handler: function (val) {
        if (val === null || val === undefined) {
          this.invalidSurfaceArea = false;
          return;
        }

        this.invalidSurfaceArea = !this.isFloat(val) || val <= 0;
      },
      immediate: true
    },
    'markUpPercentage': {
      handler: function (val) {
        this.invalidMarkupPercentage = !this.isFloat(val);
      },
      immediate: true
    },
    'selectedJobType': {
      handler: function () {
        this.$store.dispatch('pce/fetchAndAssignJobConfig', this.selectedJobType.name).then(() => {
          this.setModifiers();
        });
      }
    },
    // 'selectedModifiers': {
    //   handler: function () {
    //     this.calculateJobTotals();
    //   },
    //   deep: true
    // },
    'deviceIsMobile': {
      handler: function (val) {
        console.log('inside the deviceIsMobile ', val)
        this.showButton = val;
        if (val === false) {
          this.showSection = true;
        }
      },
      immediate: true
    }
  },
  beforeMount() {
    if (window.innerWidth <= 768) {
      //add Button
      this.showButton = true;
    } else {
      // remove button
      this.showButton = false;

    }
  },
  computed: {
    deviceIsMobile() {
      return this.$store.state.device.type === 'mobile';
    },
    selectedJobType() {
      return this.$store.getters['pce/selectedJobType'];
    },
    buttonLabel() {
      if (this.totalWithProfit === 0) {
        return this.showSection ? 'Hide PCE' : 'Show PCE';
      } else {
        const totalPce = Math.ceil(this.totalWithProfit);
        return '£' + totalPce.toString()
      }
    },
    jobTypes() {
      return this.$store.getters['pce/availableJobs'];
    },
    company() {
      return this.$store.state.company.selected.company;
    },
    pce() {
      return this.$store.state.pce.total ?? {total: '£23244'};
    },
    project() {
      return this.$store.state.quote.selected.quote;
    },
    projectClient() {
      return _.get(this.project, 'form.quoteInfo.customer.name', null);
    },
    modifierDescriptions() {
      return this.$store.getters['pce/modifiers'];
    },
    workSectionSpecs() {
      return this.$store.getters['pce/workSections'];
    },
    jobTypeSpecs() {
      return this.$store.getters['pce/jobTypes'];
    },
    locationModifierDescription() {
      const locationModifierDescription = _.find(this.modifierDescriptions, {name: 'Location'});
      return locationModifierDescription ? locationModifierDescription : {
        text: 'No description set for location modifier',
        image: null
      };
    },
    jobTypeModifierDescription() {
      if (!this.selectedJobType) {
        return {
          text: 'No description set for job type modifier',
          image: null
        };
      }

      const jobTypeModifierDescription = _.find(this.jobTypeSpecs, {name: this.selectedJobType.label})
      return jobTypeModifierDescription ? jobTypeModifierDescription : {
        text: 'No description set for job type modifier',
        image: null
      };
    },
    isExternalUser() {
      return this.$store.getters['user/isExternalCompany'];
    },
    jobType() {
      return this.$store.getters['pce/selectedJobType'] ? this.$store.getters['pce/selectedJobType'].label : 'Invalid job type';
    },
    jobConfig() {
      return this.$store.getters['pce/jobConfig'] ?? null;
    },
    locationModifiers() {
      return this.$store.getters['pce/locationModifiers'] ?? [];
    },
    total() {
      if (!this.totalCalculationEnabled) {
        return 0;
      }

      let total = 0;

      if (this.jobConfig) {
        _.forEach(this.calculatedJobWorkSections, buildStage => {
          _.forEach(buildStage, workSection => {
            if (workSection.enabled) {
              total += this.getWorkSectionTotal(workSection, false);
            }
          });
        });
      }

      _.forEach(this.pcSums, pcSum => {
        total += pcSum.value;
      });

      return total;
    },
    totalWithProfit() {
      if (!this.totalCalculationEnabled) {
        return 0;
      }

      return this.total + (this.total * (this.markUpPercentage / 100));
    },
    plotId() {
      const plot = _.find(this.project.plots.byPlot, {nheFileType: 'PCE'});
      return plot ? plot.id : null;
    }
  },
  methods: {
    calculateJobTotal() {
      // if (!this.jobConfig || !this.selectedJobType || !this.selectedFoundationsType || !this.selectedGroundFloorType || !this.selectedWallsType || !this.selectedRoofType || !this.selectedLocation || !this.surfaceAreaInput) {
      //   return;
      // }


      if (!this.surfaceAreaInput || !this.selectedJobType) {
        return;
      }

      this.groupByBuildStage();
      this.enableTotalCalculation();
      this.jobConfigLoaded = true;
      this.toggleVisibility();
      // if (this.deviceIsMobile) {
      //   this.toggleSection();
      // }
    },

    toggleVisibility() {
      this.isVisible = !this.isVisible;
    },

    toggleSection() {
      this.showSection = !this.showSection;
    },
    groupByBuildStage() {
      if (!this.jobConfig) {
        return [];
      }

      this.calculatedJobWorkSections = this.jobConfig.workSections.reduce((accumulator, current) => {
        if (!accumulator[current.buildStage]) {
          accumulator[current.buildStage] = [];
        }
        const workSection = {...current, enabled: true, percentageChange: 0, modifier: 0};
        accumulator[current.buildStage].push(workSection);
        return accumulator;
      }, {});
    },
    setModifiers() {
      if (!this.jobConfig.workSections) {
        return {};
      }

      this.workSectionsConfigWithModifiers = [];
      this.selectedModifiers = {};

      _.forEach(this.jobConfig.workSections, (workSection) => {
        if (workSection.modifiers.length > 0) {
          const newWorkSection = _.cloneDeep(workSection);

          _.map(newWorkSection.modifiers, (modifier) => {
            modifier.spec = _.find(this.modifierDescriptions, {name: modifier.label});
            return modifier;
          });

          this.workSectionsConfigWithModifiers.push(newWorkSection);
        }
      });
    },
    togglePCSumInput(toggleValue) {
      this.isModalActive = toggleValue;
    },
    enableTotalCalculation() {
      this.totalCalculationEnabled = true;
    },
    addPCSum() {
      this.pcSums.push({
        name: this.pcSumName,
        value: parseFloat(this.pcSumValue) || 0
      });
      this.pcSumValue = 0;
      this.pcSumName = '';

      this.calculateJobTotal();
      this.togglePCSumInput(false);
    },
    removePCSum(index) {
      this.pcSums.splice(index, 1);
      this.calculateJobTotal();
    },
    getWorkSectionTotal(workSection) {
      //TODO: optimize this after Demo has been completed to use the attribute in the workSection object rather than relying on Vue.$set for the modifiers
      const rawWorkSectionTotal = workSection.costPerM2 * this.surfaceAreaInput;
      let workSectionTotal = rawWorkSectionTotal + rawWorkSectionTotal * (workSection.percentageChange / 100);
      const workSectionModifier = _.get(this.selectedModifiers, workSection.name, null);

      if (workSectionModifier) {
        workSectionTotal += workSectionTotal * (workSectionModifier.value / 100);
      }
      // if (workSection.modifierApplied) {
      //   workSectionTotal += workSectionTotal * (workSection.modifierApplied.value / 100);
      // }

      workSectionTotal = (workSectionTotal - workSectionTotal / 100 * (this.surfaceAreaInput / 10)) * (this.selectedLocation.value / 100);

      workSection.calculatedTotal = workSectionTotal;
      workSection.calculatedTotalWithMarkUp = workSectionTotal + workSectionTotal * (this.markUpPercentage / 100);

      workSection.calculatedTotalFormatted = filters.currencyNotReduced(workSection.calculatedTotal);
      workSection.calculatedTotalWithMarkUpFormatted = filters.currencyNotReduced(workSection.calculatedTotalWithMarkUp);

      return workSection.calculatedTotal;
    },
    warning() {

    },
    setSelectedModifier(key, option) {
      _.forEach(this.calculatedJobWorkSections, (buildStage) => {
        _.forEach(buildStage, (workSection) => {
          if (workSection.name === key) {
            workSection.modifierApplied = option;
          }
        });
      });

      this.$set(this.selectedModifiers, key, option);
    },
    getSelectedModifierLabelForWorkSection(workSection) {
      const selectedModifier = _.get(this.selectedModifiers, workSection.name, null);
      return selectedModifier ? selectedModifier.label : 'Select ' + workSection.label + ' Type';
    },
    getSelectedModifierImageForWorkSection(workSection) {
      const selectedModifier = _.get(this.selectedModifiers, workSection.name, null);
      return selectedModifier && selectedModifier.spec ? selectedModifier.spec.image : null;
    },
    getSelectedModifierDescriptionForWorkSection(workSection) {
      const selectedModifier = _.get(this.selectedModifiers, workSection.name, null);
      return selectedModifier && selectedModifier.spec ? selectedModifier.spec.text : null;
    },
    getWorkSectionSpecText(workSection) {
      const workSectionSpec = _.find(this.workSectionSpecs, {name: workSection.label});
      return workSectionSpec ? workSectionSpec.text : 'No description set for work section';
    },
    getWorkSectionSpecImage(workSection) {
      const workSectionSpec = _.find(this.workSectionSpecs, {name: workSection.label});
      return workSectionSpec ? workSectionSpec.image : null;
    },
    isFloat(value) {
      if (value === null || value === undefined) {
        return true;
      }

      const floatRegex = /^-?\d*(\.\d+)?$/;
      return floatRegex.test(value) && value !== '' && value >= 0;
    },
    loadSubmissionForm() {
      this.showForm = true;
    },
    getTooltipPosition(index) {
      const calculatedJobWorkSectionsKeys = Object.keys(this.calculatedJobWorkSections);
      const currentIndex = calculatedJobWorkSectionsKeys.indexOf(index);

      switch (currentIndex) {
        case 0:
          return 'is-bottom';
        case 1:
          return 'is-right';
        case 2:
          return 'is-right';
        case 3:
          return 'is-right';
        case 4:
          return 'is-top';
        case 5:
          return 'is-top';
        default:
          return 'is-top';
      }
    },
    saveProjectProgress() {
      if (!this.plotId) {
        this.$buefy.snackbar.open({
          message: 'No plot found for this project, please contact the office or request a callback',
          type: 'is-danger',
          position: 'is-top',
          indefinite: true,
          actionText: 'Request Callback',
          cancelText: 'Cancel',
          onAction: () => {
            this.requestCallback();
          }
        });
        return;
      }

      this.$store.dispatch('quote/savePCEProgress', {
        quoteId: this.project._id,
        plotId: this.plotId,
        pceProgress: {
          total: this.total,
          totalWithProfit: this.totalWithProfit,
          pcSums: this.pcSums,
          jobType: {name: this.selectedJobType.name, label: this.selectedJobType.label},
          jobConfig: this.jobConfig,
          selectedModifiers: this.selectedModifiers,
          surfaceAreaInput: this.surfaceAreaInput,
          markUpPercentage: this.markUpPercentage,
          selectedLocation: this.selectedLocation,
          calculatedJobWorkSections: this.calculatedJobWorkSections,
          workSectionsConfigWithModifiers: this.workSectionsConfigWithModifiers,
        }
      }).then(() => {
        this.$buefy.snackbar.open({
          message: 'Your progress has been saved',
          type: 'is-success',
          position: 'is-top',
          actionText: 'OK',
          indefinite: true,
        })
      }).catch((error) => {
        this.$buefy.snackbar.open({
          message: 'Error saving estimate progress, please contact the office or request a callback',
          type: 'is-danger',
          position: 'is-top',
          indefinite: true,
          actionText: 'Request Callback',
          cancelText: 'Cancel',
          onAction: () => {
            this.requestCallback();
          }
        });
      });
    },
    openReportGenerator() {
      let buildStages = [];

      _.forEach(this.calculatedJobWorkSections, (buildStage, index) => {
        let buildStageObject = {
          name: filters.title(index),
          value: 0,
          workSectionsIncluded: [],
        };

        _.forEach(buildStage, (workSection) => {
          if (workSection.enabled) {
            buildStageObject.value += workSection.calculatedTotalWithMarkUp;
            buildStageObject.workSectionsIncluded.push(workSection.label);
          }
        });

        buildStages.push(buildStageObject);
      });

      this.$router.push({
        name: 'report-generator',
        params: {
          buildStages: buildStages,
          totalWithoutVAT: this.total,
          pcSums: this.pcSums,
          jobType: this.jobType
        }
      });
    },
    requestCallback() {
      this.$store.dispatch('company/requestCallback', {
        company: this.$store.getters['company/selectedCompany'],
        message: 'Callback requested from Co-Pilot',
        mentions: ['Callum Marshall', 'Ariana Reeve']
      });
    }
  },
}

</script>

<style lang="scss" scoped>
.primary-cost-estimate {
  .label {
    font-size: 1.125rem;
    font-weight: bold;
    text-align: left;
    color: $primary;
  }

  .box {
    max-height: none !important;
    margin-bottom: 0 !important;

    &.modal-content {
      max-width: 400px;
    }
  }

  .primary-cost-estimate-controller {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;

    .descriptions-container {
      display: flex;
      flex-direction: column;
      height: 100%;
      width: 100%;
      padding: 10px;
    }

    .estimate-builder-container {
      display: flex;
      flex-direction: row;
      gap: 4em;
      padding: 10px;
      height: 100%;
      width: 100%;

      .estimate-config-container {
        border: 1px solid gray;
        display: flex;
        flex-direction: column;
        gap: 0.2em;
        justify-content: flex-start;
        height: 100%;
        width: 50%;
        position: sticky;
        top: 0;

        .totals-container {
          display: flex;
          flex-direction: row;
          gap: 0.5em;

          > * {
            flex: 1;
          }

          .total {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            height: 100%;

            .total-label {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              gap: 0;
              height: 100%;
              width: 100%;
            }
          }
        }

        .buttons-container {
          display: flex;
          flex-direction: row;
          gap: 0.5em;
          height: 100%;
          width: 100%;

          > * {
            flex: 1;
          }
        }

        .address-container {
          padding-bottom: 5px;
          border-bottom: 1px solid $primary;
        }

        .button {
          margin-block: 0.5em;
        }

        .row {
          display: flex;
          flex-direction: row;
          gap: 4em;
          flex-wrap: nowrap;
          justify-content: space-between;

          > * {
            flex: 1;
          }
        }
      }

      .estimate-values-container {
        display: flex;
        flex-direction: column;
        height: 100%;
        width: 100%;

        .build-stage-container {
          display: flex;
          flex-direction: column;
        }

        .pc-sums-container {
          width: 100%;
          padding-bottom: 2rem;
        }

        .build-stage-container {
          display: flex;
          flex-direction: column;
          gap: 0.5em;
          width: 100%;

          .work-section {
            display: flex;
            flex-direction: row;
            width: 100%;
            padding-left: 30px;
            justify-content: flex-start; // Or flex-start if you don't want them to spread out
            align-items: center;
            gap: 1em;

            > * {
              flex: 1; // This will make sure all direct children (the b-field and b-slider) take equal width
            }
          }

          .work-section-label {
            color: $primary;
          }

          .work-section-slider {
            margin-bottom: 2em;
          }
        }
      }
    }
  }
}

@media (max-width: 767px) {
  .PCEButton {
    position: fixed;
    z-index: 1000;
    margin-left: 20%;
    margin-bottom: 10px;
  }

  #mobileSliders {
    padding: 0;
    width: 350px;
    margin-top: 40px;

    .work-section-slider {
      margin-left: 5px;
      margin-right: 5px;
    }

    #mobileSliderLabelAndImage {
      display: inline-block;
    }

    .work-section-label {
      display: grid;
      grid-template-columns: repeat(2, 100px);
      grid-template-rows: 1fr;
      text-align: center;
    }


    #mobileSliderSpan {
      width: 325px;
      display: grid;
      grid-template-columns: 20px 90px 1fr;
      grid-template-rows: 1fr;
    }

    .mobileViewSliderLabel {
      font-size: 1.125rem;
      font-weight: bold;
      text-align: center;
      text-decoration: underline;
      color: $primary;
    }

    #sliderSections {
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: repeat(2, 1fr);
      padding-left: 15px;
    }

  }

  #sliders {
    border: 1px solid gray;
  }

  .primary-cost-estimate .primary-cost-estimate-controller .estimate-builder-container .estimate-config-container {
    width: 350px;
    overflow-y: visible;
  }
}

//@include phone {
//
//  .PCEButton {
//    width: 100vw;
//    margin-left: -10px;
//  }
//
//  #overViewPCE {
//    white-space: nowrap;
//    left: 0;
//    margin: 0;
//    height: 100%;
//    width: auto;
//    display: flex;
//  }
//
//  #toggleSectionButton {
//    position: fixed;
//    z-index: 100;
//    bottom: 20px;
//    left: -20px;
//    margin-bottom: 20px;
//    padding-left: 25px;
//    background-color: #007bff;
//    color: white;
//    height: 40px;
//    text-align: center;
//    font-size: 15px;
//    cursor: pointer;
//    transition: background-color 0.3s;
//  }
//
//  #sectionPCE {
//    position: fixed !important;
//    z-index: 99;
//    display: flex;
//    left: 0;
//    width: 100%;
//    max-width: 390px;
//    top: 0;
//    float: none;
//    margin-top: 100px;
//    overflow: auto;
//    height: 83%;
//  }
//
//  #sliders {
//    position: relative;
//    z-index: 98;
//    display: block;
//    padding-top: 50px;
//    margin: 0 auto;
//    text-align: center;
//    overflow-y: visible;
//    clear: both;
//  }
//
//  .sliding-section {
//    width: 100%;
//    transition: width 2s;
//    transform: translateX(0);
//  }
//
//  .hidden {
//    transform: translateX(-100%);
//  }
//}
</style>